import { Pipe, PipeTransform } from '@angular/core';
import {
	ActivityInstantSource,
	resolveActivityInstant,
} from '../util/resolve-instant';

/** Resuelve el instante de una actividad (`activity_at` o legacy). */
@Pipe({
	name: 'activityInstant',
	standalone: false,
})
export class ActivityInstantPipe implements PipeTransform {
	transform(activity: ActivityInstantSource | null | undefined): string | null {
		return resolveActivityInstant(activity);
	}
}
